import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { pipe } from 'ramda';
import { fromAxiosError } from './ClientError';
export var CLIENT_CONTEXT = 'apiClient';
export var GRAPHQL_CLIENT_CONTEXT = 'graphqlClient';
export var toData = function toData(response) {
  return response.data;
};
export var pipeData = function pipeData(mapper) {
  return function (response) {
    return mapper(toData(response));
  };
}; // Useful for when actual API response has a data property containing the primary content.

export var pipeDataTwice = pipe(pipeData, pipeData);
export var toError = function toError(error) {
  return fromAxiosError(error);
};
export var pipeError = function pipeError(errorHandler) {
  return function (error) {
    return errorHandler(toError(error));
  };
}; // When passed as config to requests, prevents 401 handling.

export var toSkipErrorHandlingConfig = function toSkipErrorHandlingConfig() {
  var mixin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var skipErrorHandlers = arguments.length > 1 ? arguments[1] : undefined;
  var mergedSkipErrorHandlers = skipErrorHandlers !== null && skipErrorHandlers !== void 0 ? skipErrorHandlers : {
    skipAll: true
  };
  return _objectSpread({
    meta: {
      skipErrorHandlers: mergedSkipErrorHandlers
    }
  }, mixin);
}; // TODO: Update with values accepted for the `Peloton-Platform` header.